export const schema = {
    "models": {
        "NewPcrTest": {
            "name": "NewPcrTest",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "indexNumber": {
                    "name": "indexNumber",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "firstName": {
                    "name": "firstName",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "middleName": {
                    "name": "middleName",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "lastName": {
                    "name": "lastName",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "personalId": {
                    "name": "personalId",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "age": {
                    "name": "age",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "complaints": {
                    "name": "complaints",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "contacted": {
                    "name": "contacted",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "payment": {
                    "name": "payment",
                    "isArray": false,
                    "type": {
                        "enum": "Payment"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "previousTests": {
                    "name": "previousTests",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "testResult": {
                    "name": "testResult",
                    "isArray": false,
                    "type": {
                        "enum": "TestResult"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "testDate": {
                    "name": "testDate",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "resultDate": {
                    "name": "resultDate",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "sex": {
                    "name": "sex",
                    "isArray": false,
                    "type": {
                        "enum": "Sex"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "comment": {
                    "name": "comment",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "published": {
                    "name": "published",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "phoneNumber": {
                    "name": "phoneNumber",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "checkedOut": {
                    "name": "checkedOut",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                }
            },
            "syncable": true,
            "pluralName": "NewPcrTests",
            "attributes": [
                {
                    "type": "model",
                    "properties": {}
                }
            ]
        }
    },
    "enums": {
        "Payment": {
            "name": "Payment",
            "values": [
                "Payed",
                "RZI",
                "MBAL",
                "NotPayed",
                "Razlog",
                "TUB",
                "AUB",
                "PIRIN",
                "QuickTest"
            ]
        },
        "TestResult": {
            "name": "TestResult",
            "values": [
                "Positive",
                "Negative",
                "Doubtful",
                "InProgres"
            ]
        },
        "Sex": {
            "name": "Sex",
            "values": [
                "Male",
                "Female"
            ]
        }
    },
    "nonModels": {},
    "version": "65532e198b6c0ae7419853ffe69f597e"
};